import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { S25DeleteModule } from "../../../../../s25-delete/s25.delete.module";
import { S25EditableModule } from "../../../../../s25-editable/s25.editable.module";
import { S25ItemComponent } from "../../../../../s25-item/s25.item.component";
import { Item } from "../../../../../../pojo/Item";
import { S25RsReservation, rsrvType } from "../../../../ReservationI";
import { OccurrenceDeleteWarning } from "./occurrence.details.shared";

@Component({
    selector: "occurrence-resource-row",
    template: `<div class="resource">
        <div>
            <s25-item
                [itemId]="resource().itemId"
                [itemTypeId]="Item.Ids.Resource"
                [itemName]="resource().itemName"
                [includeTypeIcon]="true"
                [typeIconClass]="rsrvType() === 'requested' || rsrvType() === 'draft' ? 'icon-resource-pending' : ''"
            />
            @if (canEdit() && (resource().hasPerm || isModalSaveMode())) {
                <div>
                    <button
                        class="aw-button aw-button--danger--transparent"
                        (click)="confirmDelete.emit()"
                        [disabled]="
                            deleteWarning().index === index() &&
                            deleteWarning().objType === 'resource' &&
                            deleteWarning().rsrvType === rsrvType()
                        "
                    >
                        {{ rsrvType() === "requested" ? "Cancel Request" : "Remove" }}
                    </button>
                    @if (showConflict()) {
                        <button type="button" class="c-textButton ngRed" (click)="openSpaceConflict.emit()">
                            Conflict
                        </button>
                    }
                </div>
            }
        </div>
        @if (
            deleteWarning().index === index() &&
            deleteWarning().objType === "resource" &&
            deleteWarning().rsrvType === rsrvType()
        ) {
            <s25-ng-delete-inline
                [confirmMsg]="deleteWarning().msg"
                [listItems]="deleteWarning().listItems"
                (onConfirm)="deleteConfirm.emit($event)"
            ></s25-ng-delete-inline>
        } @else if (resource().hasPerm || isModalSaveMode()) {
            <label>
                Quantity:
                <s25-ng-editable-number
                    [val]="resource().quantity"
                    [readOnly]="!canEdit() || !(resource().hasPerm || isModalSaveMode())"
                    [min]="1"
                    [max]="resource()?.currentStockLevel || 65536"
                    [hasCommit]="!isModalSaveMode()"
                    [hasCancelButton]="!isModalSaveMode()"
                    [hasCommitButton]="!isModalSaveMode()"
                    commitButtonText="Save"
                    cancelButtonText="Cancel"
                    (valChange)="quantityChange.emit($event)"
                >
                </s25-ng-editable-number>
            </label>
            <div>
                <label>
                    Instructions:
                    <s25-ng-editable-textarea
                        [(val)]="resource().instructions"
                        [readOnly]="!canEdit() || !(resource().hasPerm || isModalSaveMode())"
                        placeholder="Add instructions"
                        [hasCommit]="!isModalSaveMode()"
                        [hasCancelButton]="!isModalSaveMode()"
                        [hasCommitButton]="!isModalSaveMode()"
                        [renderHtml]="true"
                        commitButtonText="Save"
                        cancelButtonText="Cancel"
                        (valChange)="textareaChange.emit($event)"
                    >
                    </s25-ng-editable-textarea>
                </label>
            </div>
        }
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25ItemComponent, S25DeleteModule, S25EditableModule],
})
export class OccurrenceResourceRowComponent {
    readonly resource = input.required<S25RsReservation>();
    readonly rsrvType = input.required<rsrvType>();
    readonly index = input.required<number>();
    readonly canEdit = input<boolean>();
    readonly isModalSaveMode = input(false);
    readonly showConflict = input(false);
    readonly deleteWarning = input.required<OccurrenceDeleteWarning>();

    readonly confirmDelete = output<void>();
    readonly openSpaceConflict = output<void>();
    readonly deleteConfirm = output<boolean>();
    readonly quantityChange = output<number>();
    readonly textareaChange = output<string>();

    protected readonly Item = Item;
}
